module.exports = __webpack_public_path__ + "img/mobiletodo.a998ee8f.png";